export default {
  transactions: [],
  transaction: null
}
